import React, { useState, useEffect } from "react";

import './../PopUp.css';
import './InfGraffic.css';

import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

export default function PopUp_InfGraffic() {

    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);
    
    function ClosePopUp(){
        SetModalState('InfGraffic', false);
    }
    
    useEffect(()=>{
        RegisterModalData('InfGraffic', setModaldata);
        RegisterModalObserver('InfGraffic', setShowPopUp);
    }, []);      

    return(
        (showPopUp ?
            <div className="PopUp PopUpCenter">

            </div>
        : <React.Fragment></React.Fragment>)
    )
}